import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ButtonIcon = ({
  handleClick,
  handleKeyPress,
  bootstrapIcon = 'bi-emoji-smile',
  backgroundColor = 'bg-success',
  tooltipText = '',
}) => {
  const button = (
    <button
      className="action-button-two"
      type="button"
      onClick={handleClick}
      onKeyDown={handleKeyPress}
      aria-label={tooltipText || 'Action'}
    >
      <i className={`bi ${bootstrapIcon} action-button ${backgroundColor}`} />
    </button>
  );

  return tooltipText ? (
    <OverlayTrigger overlay={<Tooltip>{tooltipText}</Tooltip>}>
      {button}
    </OverlayTrigger>
  ) : (
    button
  );
};

ButtonIcon.propTypes = {
  handleClick: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
  bootstrapIcon: PropTypes.string,
  backgroundColor: PropTypes.string,
  tooltipText: PropTypes.string,
};

export default ButtonIcon;
